module.exports = __webpack_public_path__ + "assets/password-strength-sterk.svg";